import * as React from "react";
import styled, { css } from "../../../styled";
import { InputGroup } from "../input.group";
import { FaExclamationCircle } from "react-icons/fa";
import lighten from "polished/lib/color/lighten";
import { CS } from "../../../styles";
import { shadeAlternate } from "../../..";
const FormGroupComponent = styled("div") `
  margin-bottom: 20px;
  padding-bottom: 20px;
  border-bottom: 1px dashed ${({ theme }) => theme.colors.border};
  &:only-child {
    border-bottom: none;
    margin-bottom: 0;
    padding-bottom: 0;
  }
  &:last-child {
    border-bottom: none;
    margin-bottom: 0;
    padding-bottom: 0;
  }
  ${(props) => props.no_border
    ? css `
          border-bottom: none;
          padding-bottom: 0;
          margin-bottom: 20px;
          &:last-child {
            margin-bottom: 0;
            padding-bottom: 0;
          }
        `
    : ""};
  ${(props) => props.not_last
    ? css `
          margin-bottom: 20px;
          padding-bottom: 20px;
          border-bottom: 1px dashed ${({ theme }) => theme.colors.border};
        `
    : ""};
`;
const FormGroupLabel = styled("div") `
  margin-bottom: 10px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  > .title {
    font-size: ${({ theme, small_title }) => theme.font.size + (small_title ? 0 : 2)}px;
    line-height: ${({ theme }) => theme.font.size + 8}px;
    font-weight: 600;
  }
  > .optional {
    padding: 3px 5px;
    border: 1px solid ${({ theme }) => shadeAlternate(0.5, theme.colors.text)};
    color: ${({ theme }) => shadeAlternate(0.25, theme.colors.text)};
    font-size: ${({ theme }) => theme.font.size - 2}px;
    font-weight: 600;
    border-radius: 5px;
    text-transform: uppercase;
  }
`;
const FormGroupContent = styled("div") ``;
const FormGroupHelp = styled("span") `
  display: block;
  margin-top: 10px;
  font-size: ${({ theme }) => theme.font.size}px;
  line-height: ${({ theme }) => theme.font.size + 8}px;
`;
const FormGroupError = styled("span") `
  ${CS.flex.line_center};
  margin-top: 10px;
  font-size: 14px;
  line-height: 1.3;
  color: ${({ theme }) => theme.colors.error};
  background: ${({ theme }) => lighten(0.43, theme.colors.error)};
  padding: 5px 10px;
  border-radius: 3px;
`;
export function FormGroup(props) {
    if (props.hide)
        return null;
    function Label() {
        if (!props.title && !props.optional) {
            return null;
        }
        return (React.createElement(FormGroupLabel, { small_title: props.small_title },
            props.title && React.createElement("label", { className: "title" }, props.title),
            props.optional && React.createElement("span", { className: "optional" }, "Optional")));
    }
    function Help() {
        return !props.help ? null : (React.createElement(FormGroupHelp, { className: props.contentInline ? "!-mt-2" : "" }, props.help));
    }
    function Error() {
        return !props.error ? null : (React.createElement(FormGroupError, { className: props.contentInline ? "!-mt-1" : "" },
            React.createElement(FaExclamationCircle, { className: "mr-2" }),
            React.createElement("span", null, props.error)));
    }
    if (props.contentInline) {
        return (React.createElement(FormGroupComponent, { style: props.style, className: props.className, no_border: props.no_border, not_last: props.not_last },
            React.createElement("div", { className: "flex justify-between items-center" },
                React.createElement("div", { className: "mr-4" },
                    React.createElement(Label, null),
                    React.createElement(Help, null),
                    React.createElement(Error, null)),
                React.createElement(FormGroupContent, { className: props.contentClassName }, props.children))));
    }
    return (React.createElement(FormGroupComponent, { style: props.style, className: props.className, no_border: props.no_border, not_last: props.not_last },
        React.createElement("div", null,
            React.createElement(Label, null),
            React.createElement(FormGroupContent, { className: props.contentClassName }, props.children)),
        React.createElement(Help, null),
        React.createElement(Error, null)));
}
export class FormGroupIcon extends React.PureComponent {
    render() {
        const { props } = this;
        if (props.hide)
            return null;
        return (React.createElement(FormGroupComponent, { style: props.style, className: props.className, no_border: props.no_border, not_last: props.not_last },
            props.title && (React.createElement(FormGroupLabel, { small_title: props.small_title }, props.title)),
            React.createElement(FormGroupContent, { className: props.contentClassName },
                React.createElement(InputGroup, { icon: props.icon, iconHtml: props.icon_html, className: props.icon_class, iconStyle: props.icon_style }, props.children)),
            props.help && React.createElement(FormGroupHelp, null, props.help)));
    }
}
//# sourceMappingURL=index.js.map